'use client';

import { useGameStore } from '@/store/useGameStore';

interface Props {
  size?: 'sm' | 'md' | 'lg';
}

export function StreakDisplay({ size = 'md' }: Props) {
  const streak = useGameStore((s) => s.streak);

  if (streak === 0) return null;

  const fontSize = size === 'sm' ? '14px' : size === 'lg' ? '20px' : '16px';

  return (
    <span
      className="inline-flex items-center gap-1 font-bold"
      style={{ fontSize, color: '#FF6B6B' }}
      title={`${streak} day streak`}
      aria-label={`${streak} day streak`}
    >
      <span className="flame" aria-hidden="true">🔥</span>
      {streak}
    </span>
  );
}
